import { Reducer } from "redux";

import { CheckEligibilityResponse } from "../models/Api/CheckEligibility";
import { EligibilityCheckActionDispatchTypes } from "../models/DispatchTypes/CheckEligibility";
import { EligibilityCheckDispatchTypes } from "../constants/ReferralRequestor";

const initialState: CheckEligibilityResponse = {
  loading: false,
  response: {
    eligibilityId: 0,
    eligibilityStatus: "",
    verificationServiceResponded: false
  },
  error: null,
};

const CheckEligibilityReducer: Reducer<
  CheckEligibilityResponse,
  EligibilityCheckActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case EligibilityCheckDispatchTypes.CHECK_ELIGIBILITY_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case EligibilityCheckDispatchTypes.CHECK_ELIGIBILITY_SUCCESS: {
      return {
        ...state,
        error: null,
        response: action.response,
        loading: false,
      };
    }
    case EligibilityCheckDispatchTypes.CHECK_ELIGIBILITY_ERROR: {
      return {
        ...state,
        error: action.response,
        response: null,
        loading: false,
      };
    }
    case EligibilityCheckDispatchTypes.CHECK_ELIGIBILITY_RESET: {
      return initialState;
    }
  }
  return state;
};

export default CheckEligibilityReducer;
